<template>
  <a class="c-button button" href="https://moonshot.ch/">
    <div class="button__text">
     {{ data.content }}
    </div> 
  </a>
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  padding: 15px 20px;
  border: 1px solid $color-white;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255,1) 0%,
    rgba(255, 255, 255, 1) 25%,
    rgba(255, 255, 255, 0) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  transition: background-position 0.4s $outQuint;
  background-size: 400% 400%;
  background-position: 0% 0%;

  cursor: pointer;

  &__text {
    color: $color-black;
    text-transform: uppercase;
    font-family: $font-family-text;
    font-weight: 500;
    font-size: 10px;
    letter-spacing: 3px;

    transition: color 0.4s $outQuint;
  }

  @include mq($and: $is-not-touch-device) {
    &:hover {
      background-position: 0% 100%;

      .button__text {
        color: $color-white;
      }
    }
  }
}
</style>
